import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { result } from 'lodash';
import moment from 'moment';

@Component({
  selector: 'app-single-month-calendar',
  templateUrl: './single-month-calendar.component.html',
  styleUrls: ['./single-month-calendar.component.scss']
})
export class SingleMonthCalendarComponent implements OnInit {
  allYears: number[] = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - (5 - i));
  months: string[] = [];
  selectedMonth!: string | null;

  minMonth!: string; 
  maxMonth!: string;
  headerName:any='Date Selection'
  @Input('selectedData') selectedData: any;
  @Input('DateConfig') DateConfig: any;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();

  minYear!: number; 
  maxYear!: number; 
  selectedYear!: number;
  selectedStartMonth:any
  selectedEndMonth:any
  startYear: number|any = 2023; // Default start year
  endYear: number|any = new Date().getFullYear(); // Default end year
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedData']?.currentValue!=changes['selectedData']?.previousValue) {
      this.months = this.generateMonths([Number(moment(this.selectedData.to_date).format('YYYY'))]);
      this.selectedMonth = moment(this.selectedData.from_date).format('MMM YYYY');
      this.minYear = Number(moment(this.DateConfig.option.minDate).format('YYYY'));
      this.maxYear = Number(moment(new Date()).format('YYYY'));
      this.minMonth = moment(this.DateConfig.option.minDate).format('MMM YYYY');
      this.maxMonth = moment(new Date()).format('MMM YYYY');
      this.selectedYear = this.minYear;
      this.startYear= Number(moment(this.selectedData.to_date).format('YYYY'));
    
      const result = this.getMonthStartEndFromString(this.selectedMonth);
      this.selectedStartMonth = new Date(result.startDate);
      this.selectedEndMonth = new Date(result.endDate);
    }
  }

  onYearSelected(year: number) {
    this.selectedYear = year;
    this.months = this.generateMonths([year]);
  }

  generateMonths(years: number[]): string[] {
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return years.flatMap(year => monthNames.map(m => `${m} ${year}`));
  }

  get disabledYearsForStartSelector(): number[] {
    const disabledYears = [];
    // Disable all years after the endYear
    for (let year = this.endYear + 1; year <= this.maxYear; year++) {
      disabledYears.push(year);
    }
    return disabledYears;
  }
  onStartYearSelected(year: number) {
    if (year > this.endYear) {
      // If the selected start year exceeds the current end year, adjust the end year
      this.endYear = year;
    }
    this.startYear = year;
    this.onYearSelected( this.startYear)
  }

  selectMonth(month: string) {
    // debugger
    this.selectedMonth = month;
    const result = this.getMonthStartEndFromString(this.selectedMonth);
    this.selectedStartMonth = new Date(result.startDate);
    this.selectedEndMonth = new Date(result.endDate);
  }

  isSelected(month: string): boolean {
    return this.selectedMonth === month;
  }

  isDisabled(month: string): boolean {
    const monthDate = new Date(month);
    const minDate = new Date(this.minMonth);
    const maxDate = new Date(this.maxMonth);
    return  monthDate < minDate || monthDate > maxDate;
}

  // getMonthStartDate(month: string): Date {
  //   const [m, year]: any = month.split(' ');
  //   const monthNames = [
  //     'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  //     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  //   ];
  //   const monthIndex = monthNames.indexOf(m);
  //   return new Date(year, monthIndex, 1);
  // }

  // getMonthEndDate(month: string): Date {
  //   const [m, year]: any = month.split(' ');
  //   const monthNames = [
  //     'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  //     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  //   ];
  //   const monthIndex = monthNames.indexOf(m);
  //   return new Date(year, monthIndex + 1, 0);
  // }

 getMonthStartEndFromString(monthYear:any) {
    const date = moment(monthYear, "MMM YYYY"); // Parse "Oct 2024"
    const startDate = date.startOf('month').format('YYYY-MM-DD');
    const endDate = date.endOf('month').format('YYYY-MM-DD');
    
    return { 'startDate':startDate, 'endDate':endDate };
}
  clearDates() {
    this.selectedStartMonth = null;
    this.selectedEndMonth = null;
  }

  applyDates() {
    if (this.selectedStartMonth && this.selectedEndMonth) {
      this.applyFilter.emit({
        from_date: this.selectedStartMonth,
        to_date: this.selectedEndMonth,
      });
    } else {
      alert('Please select both start and end months.');
    }
    //menu close
    document.getElementById("du-page")?.click()
  }
}

